<template>
  <div
    class="flex align-center ag-row-with-bg"
    style="width: 100%; height: 100%; padding-left: 10px"
  >
    <div
      v-if="params.data.date != null && params.data.amountMoney !== null"
      class="flex"
    >
      <div style="width: 200px; margig-right: 10px">
        Ngày {{ params.data.date }}
      </div>
      <div style="width: 200px">
        Tổng: {{ $displayCurrency(params.data.amountMoney) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.ag-row-with-bg {
  background-color: $ag-selected-row-background-color;
}
</style>
